import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';

import { Course as ICourse } from '@/components/Courses/CoursesCard';
import CategoryBadge from '@/components/Layout/Header/Search/Suggestions/Badge/Category';

interface Props {
  course?: ICourse;
  onClickBook?: () => void;
}

const Course: FC<Props> = ({ course, onClickBook }) => {
  return (
    <motion.div
      key={course?._id}
      layout
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className='relative sm:w-[200px] w-[170px] sm:min-w-[200px] min-w-[170px] aspect-[200/100] rounded overflow-hidden'
    >
      <Link
        onClick={(e) => {
          e.stopPropagation();
          onClickBook?.();
        }}
        href={`/courses/${course?.productSlug}?id=${course?.productId}`}
        className='relative sm:w-[200px] w-[170px] sm:min-w-[200px] min-w-[170px] aspect-[200/100] rounded overflow-hidden'
      >
        <div className='relative sm:w-[200px] w-[170px] sm:min-w-[200px] min-w-[170px] aspect-[200/100] rounded overflow-hidden'>
          <Image
            width={200}
            height={100}
            className='w-full h-full object-cover'
            src={course?.form?.bookImage}
            alt='Course'
          />
          <CategoryBadge
            type='COURSE'
            className='bg-gradient-to-b from-[#755BDF] to-[#2C1FA3]'
          />
        </div>
      </Link>
    </motion.div>
  );
};

export default Course;
